import { useGame } from "../../data/gameContext";
import "./gameHeader.css";

export default function GameHeader() {
  const { gameState, getGameTime } = useGame();

  return (
    <header className="game-header">
      <div className="game-header-left">
        {gameState.PlayerCharacter?.Name}
        <div className="player-money">
          💰 ${gameState.PlayerCharacter?.Money}
        </div>
      </div>
      <div className="game-header-right">
        {getGameTime()}
      </div>
    </header>
  );
}
